import { render, staticRenderFns } from "./testResultTotal.vue?vue&type=template&id=d6e1757a&scoped=true"
import script from "./testResultTotal.vue?vue&type=script&lang=js"
export * from "./testResultTotal.vue?vue&type=script&lang=js"
import style0 from "./testResultTotal.vue?vue&type=style&index=0&id=d6e1757a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6e1757a",
  null
  
)

export default component.exports